<template>
  <div class="uk-modal-dialog uk-modal-body uk-margin-auto-vertical form uk-width-3-4">
    <Form @submit="onBeforeSubmit" :validation-schema="validationSchema" ref="form" :initial-values="formValues">
      <div class="uk-modal-header form-header">
        <span class="uk-text-bold uk-text-large">{{ broadcastGroup ? "実施内容編集" : "新規アセスメントサーベイ追加" }}</span>
      </div>
      <div class="uk-modal-body">
        <div class="column-2">
          <div>
            <FormError :errors="globalErrors" />
            <div class="field" v-if="broadcastGroup">
              <FieldLabel title="種別" />
              <Field name="type">
                <span>&emsp;{{ broadcastGroup.typeName }}</span>
              </Field>
            </div>
            <div class="field" v-else>
              <FieldLabel title="種別" :required="true" />
              <Field name="type" v-slot="{ field }">
                <select class="uk-select" v-bind="field" @change="onTypeSelectionChange">
                  <option :value="bcType.Employee">従業員</option>
                  <option v-if="isApplicantSelectable" :value="bcType.Applicant">応募者</option>
                </select>
              </Field>
              <FieldError name="type" />
            </div>
            <div class="field">
              <Field name="name" v-slot="{ field }">
                <FieldLabel title="実施内容名" :required="true" />
                <input class="uk-input" type="text" v-bind="field" />
              </Field>
              <FieldError name="name" />
            </div>
            <div class="field caption">
              <FieldLabel title="受検期間" />
            </div>
            <div class="field indent-1">
              <Field name="startDate">
                <FieldLabel title="受検開始日時" :required="true" />
                <div class="datetime-field">
                  <Datepicker
                    class="uk-input"
                    v-model="formValues.startDate"
                    :locale="locale"
                    input-format="yyyy-MM-dd"
                    :weekStartsOn="0"
                  />
                  <div>
                    <Field name="startTime">
                      <select class="uk-select" name="startTime" v-model="formValues.startTime">
                        <option v-for="index in 24" :key="index" :value="index - 1">
                          {{ index - 1 }}
                        </option>
                      </select>
                    </Field>
                    時
                  </div>
                </div>
              </Field>
              <FieldError name="startDate" />
            </div>
            <div class="field indent-1">
              <Field name="endDate">
                <FieldLabel title="受検終了日時" :required="true" />
                <div class="inline-button-group">
                  <button class="uk-button uk-button-default ex-small-button" @click.prevent="setEndDate(1)">1W</button>
                  <button class="uk-button uk-button-default ex-small-button" @click.prevent="setEndDate(2)">2W</button>
                  <button class="uk-button uk-button-default ex-small-button" @click.prevent="setEndDate(4)">4W</button>
                </div>
                <div class="datetime-field">
                  <Datepicker
                    class="uk-input"
                    name="endDate"
                    v-model="formValues.endDate"
                    :locale="locale"
                    input-format="yyyy-MM-dd"
                    :weekStartsOn="0"
                  />
                  <div>
                    <Field name="endTime">
                      <select class="uk-select" name="endTime" v-model="formValues.endTime">
                        <option v-for="index in 24" :key="index" :value="index - 1">
                          {{ index - 1 }}
                        </option>
                      </select>
                    </Field>
                    時
                  </div>
                </div>
              </Field>
              <FieldError name="endDate" />
            </div>
            <div class="field">
              <Field name="completionEmail" v-slot="{ field }">
                <FieldLabel title="受検完了メール" />
                <input class="uk-input" type="text" v-bind="field" />
              </Field>
              <FieldError name="completionEmail" />
            </div>
            <div class="field">
              <Field name="participantRemind" v-slot="{ field }">
                <FieldLabel title="受検者リマインド" />
                <HelpIcon
                  tooltipText="受検期限の3日前と1日前の正午に未受検の受検者にリマインドメールを配信します"
                  position="top-left"
                  cls="uk-active uk-width-auto"
                />
                <Toggle class="toggle-blue" v-model="formValues.participantRemind" on-label="ON" off-label="OFF" v-bind="field" />
              </Field>
              <FieldError name="participantRemind" />
            </div>
            <div class="field">
              <Field name="adminRemind" v-slot="{ field }">
                <FieldLabel title="管理者リマインド" />
                <HelpIcon
                  tooltipText="受検期限の1日前の正午にクライアント管理者宛に受検状況のお知らせメールを配信します"
                  position="top-left"
                  cls="uk-active uk-width-auto"
                />
                <Toggle class="toggle-blue" v-model="formValues.adminRemind" on-label="ON" off-label="OFF" v-bind="field" />
              </Field>
              <FieldError name="adminRemind" />
            </div>
          </div>
        </div>
      </div>
      <div class="uk-modal-footer uk-text-right form-action">
        <div>
          <ActionButton title="戻る" class="uk-modal-close" toggleTarget=".uk-modal.editor" />
        </div>
        <div class="form-action-main">
          <ActionButton v-if="broadcastGroup" title="削除" @click="onDeleteButtonClick" color="warn" />
          <ActionButton :title="broadcastGroup ? '確定' : '作成'" color="primary" type="submit" :disabled="processing" />
        </div>
      </div>
    </Form>
  </div>
</template>
<style lang="scss" scoped>
@include modal-form;
.column-2 {
  display: flex;
  justify-content: center;
  div:first-child {
    flex: 1;
  }
}
.indent-1 {
  margin-left: $spacing-medium;
}
.participants-container {
  width: 300px;
  max-height: 450px;
  min-height: 200px;
  margin-left: $spacing-medium;
  .user-selector-container {
    height: 100%;
  }
  text-align: right;
}
.participants {
  margin-top: $spacing-small;
  height: 100%;
}
.datetime-field {
  display: flex;
  select {
    margin-left: $spacing-small;
    margin-right: $spacing-minimum;
  }
  div:last-child {
    display: flex;
    align-items: center;
  }
}
.uk-modal-dialog {
  width: unset;
}
.uk-modal-dialog.uk-modal-body {
  width: 476px;
}
.uk-modal-footer {
  border: 0;
}
.uk-modal-header.add-applicant {
  border: 0;
}
.inline-button-group {
  display: inline;
  margin: 0 8px;
  .ex-small-button {
    padding: 0 8px;
    margin: 0 2px 4px 2px;
    line-height: 24px;
    font-size: 0.75rem;
    border: solid #bbb 1px;
  }
}
div.caption {
  margin-bottom: $spacing-ex-small;
}
div.toggle-container {
  margin-left: 152px;
}
.toggle-blue {
  --toggle-bg-on: #008080;
  --toggle-border-on: #008080;
}
div.field:last-child {
  margin-bottom: 0px;
}
</style>
<style src="@vueform/toggle/themes/default.css"></style>
<script lang="ts">
import { Options } from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";
import { Field, Form } from "vee-validate";
import HelpIcon from "../../atoms/HelpIcon.vue";
import FieldLabel from "../../atoms/FieldLabel.vue";
import * as yup from "yup";
import Store from "../../../store";
import FieldError from "../../atoms/FieldError.vue";
import FormError from "../../atoms/FormError.vue";
import ActionButton from "@/components/atoms/ActionButton.vue";
import { CreateAsBroadcastRequest, AsBroadcastTypeEnum, AsApi, GetAsBroadcastResponse, PricePlanEnum } from "../../../autogen";
import UserSelector from "../../molecules/UserSelector.vue";
import Datepicker from "vue3-datepicker";
import { ja } from "date-fns/locale";
import FormMixin from "../../../helpers/mixins/form";
import Toggle from "@vueform/toggle";
import { InstructionLevel } from "@/types";
import UIkit from "uikit";

type FormValues = CreateAsBroadcastRequest & {
  startTime: string;
  endTime: string;
  startDate?: Date;
  endDate?: Date;
};

@Options({
  components: {
    Field,
    Form,
    HelpIcon,
    FieldLabel,
    FieldError,
    FormError,
    ActionButton,
    Datepicker,
    UserSelector,
    Toggle
  }
})
export default class ASGroupForm extends FormMixin {
  private readonly auth = Store.getInstance().getAuth()!;
  globalErrors: { message: string }[] = [];
  @Prop({ type: Object }) broadcastGroup?: GetAsBroadcastResponse;
  formName = "アセスメントサーベイグループ";
  formValues: FormValues = {
    name: "",
    type: AsBroadcastTypeEnum.Employee,
    startDate: new Date(),
    startDateTime: "",
    endDateTime: "",
    completionEmail: "",
    startTime: "0",
    endTime: "23",
    adminRemind: false,
    participantRemind: false
  };
  locale = ja;
  validationSchema!: yup.AnyObjectSchema;
  bcType = AsBroadcastTypeEnum;
  isApplicantSelectable = false;
  beforeCreate() {
    this.validationSchema = yup.object({
      name: yup
        .string()
        .trim()
        .required(this.$t("input_required", { field: "実施内容名" })),
      type: yup.string().oneOf(Object.values(AsBroadcastTypeEnum)),
      startDate: yup.string().required(this.$t("input_required", { field: "受検開始日" })),
      endDate: yup.string().required(this.$t("input_required", { field: "受検終了日" })),
      startTime: yup.string().required(this.$t("input_required", { field: "受検開始時刻" })),
      endTime: yup.string().required(this.$t("input_required", { field: "受検終了時刻" })),
      completionEmail: yup.string().email(this.$t("input_email"))
    });
  }
  currentType: AsBroadcastTypeEnum = AsBroadcastTypeEnum.Employee;
  beforeMount() {
    if (this.broadcastGroup) {
      const startDateTime = new Date(this.broadcastGroup.startDateTime);
      const endDateTime = new Date(this.broadcastGroup.endDateTime);
      this.formValues = {
        name: this.broadcastGroup.name,
        type: this.broadcastGroup.type,
        startDateTime: this.broadcastGroup.startDateTime,
        endDateTime: this.broadcastGroup.endDateTime,
        completionEmail: this.broadcastGroup.completionEmail,
        startTime: String(startDateTime.getHours()),
        endTime: String(endDateTime.getHours()),
        startDate: startDateTime,
        endDate: endDateTime,
        adminRemind: this.broadcastGroup.adminRemind,
        participantRemind: this.broadcastGroup.participantRemind
      };
    }
    this.getPlan();
  }
  async onBeforeSubmit(values: FormValues) {
    const startDateTime = new Date(
      values.startDate!.getFullYear(),
      values.startDate!.getMonth(),
      values.startDate!.getDate(),
      values.startDate!.getHours()
    );
    startDateTime.setHours(parseInt(values.startTime));
    const endDateTime = new Date(
      values.endDate!.getFullYear(),
      values.endDate!.getMonth(),
      values.endDate!.getDate(),
      values.endDate!.getHours()
    );
    endDateTime.setHours(parseInt(values.endTime));
    await this.onSubmit(async () => {
      if (this.broadcastGroup) {
        await new AsApi().updateAsBroadcast({
          asBroadcastId: this.broadcastGroup.asBroadcastId,
          updateAsBroadcastRequest: {
            type: values.type,
            name: values.name,
            startDateTime: startDateTime.toISOString(),
            endDateTime: endDateTime.toISOString(),
            completionEmail: values.completionEmail,
            adminRemind: values.adminRemind,
            participantRemind: values.participantRemind
          }
        });
      } else {
        await new AsApi().createAsBroadcast({
          createAsBroadcastRequest: {
            type: values.type,
            name: values.name,
            startDateTime: startDateTime.toISOString(),
            endDateTime: endDateTime.toISOString(),
            completionEmail: values.completionEmail,
            adminRemind: values.adminRemind,
            participantRemind: values.participantRemind
          }
        });
      }
      this.$emit("submitted");
    });
  }
  onTypeSelectionChange(event: Event) {
    const target = event.target as HTMLInputElement;
    this.currentType = target.value as AsBroadcastTypeEnum;
  }
  async onDeleteButtonClick() {
    this.onDeleteAsg(async () => {
      await new AsApi().deleteAsBroadcast({
        asBroadcastId: this.broadcastGroup!.asBroadcastId
      });
    }, "アセスメントサーベイを削除します。よろしいでしょうか？\n※実施期間中のアセスメントサーベイを削除するには受験者を全員削除してください");
  }
  async onDeleteAsg(fn: () => Promise<void>, message?: string | string[]) {
    this.storeInstance.setInstructionContent(
      InstructionLevel.Confirm,
      message || `${this.formName}を削除します。よろしいでしょうか？`,
      async () => {
        try {
          await fn();
          this.storeInstance.setInstructionContent(InstructionLevel.Info, `${this.formName}の削除が完了しました`);
          this.$emit("deleted");
        } catch (err) {
          console.error(err);
          this.handleSubmissionError(err);
        }
      }
    );
  }
  @Watch("auth.pricePlan")
  getPlan() {
    const planCode = this.auth.pricePlan;
    this.isApplicantSelectable = planCode !== PricePlanEnum.Trial;
  }
  setEndDate(w: number) {
    if (this.formValues.startDate) {
      var dt = new Date(this.formValues.startDate);
      dt.setDate(dt.getDate() + 7 * w);
      this.formValues.endDate = dt;
    }
  }
}
</script>
